import { useApp } from "@/context/AppContext";

export default function ChildSelector() {
    const { children, activeChildId, setActiveChildId } = useApp();
    if (!children.length) return null;
    return (
        <div className="flex items-center gap-2 overflow-x-auto" data-testid="child-selector">
            {children.map((c) => {
                const active = c.id === activeChildId;
                const initial = (c.name || "?").trim().charAt(0).toUpperCase();
                return (
                    <button
                        key={c.id}
                        onClick={() => setActiveChildId(c.id)}
                        data-testid={`child-selector-${c.id}`}
                        className={`flex items-center gap-2 rounded-full border px-2 py-1 pr-3 text-sm whitespace-nowrap ${active ? "border-[#D96B43] bg-[#FFF1EA]" : "border-[#E2DCD5] bg-white hover:bg-[#F3EFEA]"}`}
                    >
                        <span
                            className="grid h-7 w-7 place-items-center rounded-full text-white text-xs font-bold"
                            style={{ backgroundColor: c.avatar_color || "#D96B43" }}
                        >
                            {initial}
                        </span>
                        <span className={active ? "font-semibold text-slate-900" : "text-slate-700"}>{c.name}</span>
                    </button>
                );
            })}
        </div>
    );
}
